module.exports = __webpack_public_path__ + "img/seating_img.dc0be6a6.png";